import z from "zod";
import { BookkeepingAccountIdScheme } from "./ids";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const BookkeepingAccountDBScheme = z.object({
  id: BookkeepingAccountIdScheme,
  name: z.string(),
  accountNumber: z.string(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
});

export const RestGetBookkeepingAccount = BookkeepingAccountDBScheme;
export const RestCreateBookkeepingAccount = BookkeepingAccountDBScheme.omit({
  id: true,
  createdAt: true,
});
export const RestUpdateBookkeepingAccount = BookkeepingAccountDBScheme.omit({
  id: true,
  createdAt: true,
}).partial();

export type DBBookkeepingAccount = z.infer<typeof BookkeepingAccountDBScheme>;
export type RestBookkeepingAccount = z.infer<typeof RestGetBookkeepingAccount>;
export type RestCreateBookkeepingAccount = z.infer<
  typeof RestCreateBookkeepingAccount
>;
export type RestUpdateBookkeepingAccount = z.infer<
  typeof RestUpdateBookkeepingAccount
>;
